import { assoc, compose, dissoc, map, pick } from 'ramda'

export const cleanRequest = map(
  compose(
    pick([
      'stockItemId',
      'operationType',
      'amount',
      'clientCode',
      'from',
      'fromUserId',
      'fromPlaceId',
      'to',
      'toUserId',
      'toPlaceId'
    ]),
    item => assoc('stockItemId', item?.item?.id, item),
    item => assoc('amount', Number(item.amount), item),
    item => assoc('operationType', item.operationType?.id, item),
    item => assoc('clientCode', item?.clientCode, item),
    item => (item.user ? assoc('fromUserId', item.user.id, item) : dissoc('fromUserId', item)),
    item => (item.user ? assoc('toUserId', item.user.id, item) : dissoc('toUserId', item)),
    item => (item.place ? assoc('fromPlaceId', item.place.id, item) : dissoc('fromPlaceId', item)),
    item => (item.place ? assoc('toPlaceId', item.place.id, item) : dissoc('toPlaceId', item))
  )
)

export const cleanStocksReplyRequest = item => {
  const result = compose(
    pick(['item', 'operationType', 'amount', 'clientCode', 'fromUserId', 'toUserId', 'fromPlaceId', 'toPlaceId']),
    item => assoc('item', { id: item?.item?.id, name: item?.item?.name }, item),
    item => assoc('toUserId', item?.toUserId, item),
    item => assoc('fromUserId', item?.fromUserId, item),
    item => assoc('toPlaceId', item?.toPlaceId, item),
    item => assoc('fromPlaceId', item?.fromPlaceId, item),
    item => assoc('operationType', item.operationType, item),
    item => assoc('amount', Number(item.amount), item),
    item => assoc('clientCode', item?.clientCode, item)
  )(item)

  return result
}
